module.exports = __webpack_public_path__ + "static/media/application.35f44e25.docx";